import styles from "./styles.module.scss";

export const Error404Page: React.FC = () => {
	return (
		<div className={styles.container}>
			<h1>404</h1>
			<p>Página Não Encontrada</p>
		</div>
	);
};
